export function loadPermissions(){

    return function(dispatch, getState){
        if(
            (
                getState().profileReducer.getProfile.domain?.plan === "ENTERPRISE"
                || getState().profileReducer.getProfile.domain?.plan === "PRO"
				|| getState().profileReducer.getProfile.domain?.plan === "BASIC"
            )
            ||
            (
                getState().profileReducer.getProfile.inviter?.plan === "ENTERPRISE"
                || getState().profileReducer.getProfile.inviter?.plan === "PRO"
				|| getState().profileReducer.getProfile.inviter?.plan === "BASIC"
            )
        ) {
            dispatch(hasContactsManagementPermission(false))
        } else {
            dispatch(hasContactsManagementPermission(true))
        }

	    if(
		    getState().profileReducer.getProfile.domain?.plan === "FREE_EDITION"
		    ||
		    getState().profileReducer.getProfile.domain?.plan === "BUSINESS"
		    ||
		    getState().profileReducer.getProfile.inviter?.plan === "BUSINESS"
	    ) {
		    dispatch(hasTheBusinessPermission(true))
	    } else {
		    dispatch(hasTheBusinessPermission(false))
	    }

	    if(
		    getState().profileReducer.getProfile.domain?.plan === "FREE_EDITION"
		    || getState().profileReducer.getProfile.domain?.plan === "BUSINESS"
	    ) {
		    dispatch(hasDeveloperApiPermission(true));
		    dispatch(hasDirectorySyncPermission(true));
	    } else {
		    dispatch(hasDeveloperApiPermission(false));
		    dispatch(hasDirectorySyncPermission(false));
	    }

    }

}

export function hasContactsManagementPermission(boolean){
    return {
        type: 'HAS_CONTACTS_MANAGEMENT_PERMISSION',
        payload: boolean
    }
}

export function hasDeveloperApiPermission(boolean){
	return {
		type: 'HAS_DEVELOPER_API_PERMISSION',
		payload: boolean
	}
}

export function hasDirectorySyncPermission(boolean){
	return {
		type: 'HAS_DIRECTORY_SYNC_PERMISSION',
		payload: boolean
	}
}

export function hasTheBusinessPermission(boolean){
	return {
		type: 'HAS_THE_BUSINESS_PERMISSION',
		payload: boolean
	}
}
